export default {
    data() {
        return {
            categories: [
                {
                    "code": "0011",
                    "name": "COMMERCE BANK ODP"
                },
                {
                    "code": "0701",
                    "name": "POSTAGE TRANSACTION CHARGE"
                },
                {
                    "code": "0742",
                    "name": "VETERINARY SERVICES"
                },
                {
                    "code": "0763",
                    "name": "AGRICULTURAL COOPERATIVES"
                },
                {
                    "code": "0780",
                    "name": "LANDSCAPE AND HORTICULTURAL SERVICES"
                },
                {
                    "code": "1520",
                    "name": "GENERAL CONTRACTORS - RESIDENTIAL BUILDINGS"
                },
                {
                    "code": "1711",
                    "name": "A/C, HEATING OR PLUMBING CONTRACTORS - SALES & INSTALLATION"
                },
                {
                    "code": "1731",
                    "name": "ELECTRICAL CONTRACTORS"
                },
                {
                    "code": "1740",
                    "name": "MASONRY, STONEWORK, TILE SETTING, PLASTERING"
                },
                {
                    "code": "1750",
                    "name": "CARPENTRY"
                },
                {
                    "code": "1761",
                    "name": "ROOFING, SHEET METAL WORK, OR SIDING -- CONTRACTORS"
                },
                {
                    "code": "1771",
                    "name": "CONTRACTORS -- CONCRETE WORK"
                },
                {
                    "code": "1799",
                    "name": "SPECIAL TRADE CONTRACTORS"
                },
                {
                    "code": "2741",
                    "name": "MISCELLANEOUS PUBLISHING AND PRINTING"
                },
                {
                    "code": "2791",
                    "name": "TYPESETTING, PLATE MAKING AND RELATED SERVICES"
                },
                {
                    "code": "2842",
                    "name": "SPECIALTY CLEANING, POLISHING AND SANITATION PREPS"
                },
                {
                    "code": "3351",
                    "name": "AFFILIATED AUTO RENTAL"
                },
                {
                    "code": "3352",
                    "name": "AMERICAN INTERNATIONAL"
                },
                {
                    "code": "3353",
                    "name": "BROOKS RENT-A-CAR"
                },
                {
                    "code": "3354",
                    "name": "ACTION AUTO RENTAL"
                },
                {
                    "code": "3355",
                    "name": "SIXT CAR RENTAL"
                },
                {
                    "code": "3357",
                    "name": "HERTZ RENT-A-CAR"
                },
                {
                    "code": "3359",
                    "name": "PAYLESS CAR RENTAL"
                },
                {
                    "code": "3360",
                    "name": "SNAPPY CAR RENTAL"
                },
                {
                    "code": "3361",
                    "name": "AIRWAYS RENT-A-CAR"
                },
                {
                    "code": "3362",
                    "name": "ALTRA AUTO RENTAL"
                },
                {
                    "code": "3364",
                    "name": "AGENCY RENT-A-CAR"
                },
                {
                    "code": "3366",
                    "name": "BUDGET RENT-A-CAR"
                },
                {
                    "code": "3368",
                    "name": "HOLIDAY RENT-A-CAR"
                },
                {
                    "code": "3370",
                    "name": "RENT-A-WRECK"
                },
                {
                    "code": "3374",
                    "name": "ACCENT RENT-A-CAR"
                },
                {
                    "code": "3376",
                    "name": "AJAX RENT-A-CAR"
                },
                {
                    "code": "3380",
                    "name": "TRIANGLE RENT A CAR"
                },
                {
                    "code": "3381",
                    "name": "EUROP CAR"
                },
                {
                    "code": "3385",
                    "name": "TROPICAL RENT-A-CAR"
                },
                {
                    "code": "3386",
                    "name": "SHOWCASE RENTAL CARS"
                },
                {
                    "code": "3387",
                    "name": "ALAMO RENT-A-CAR"
                },
                {
                    "code": "3388",
                    "name": "MERCHANTS RENT-A-CAR"
                },
                {
                    "code": "3389",
                    "name": "AVIS RENT-A-CAR"
                },
                {
                    "code": "3390",
                    "name": "DOLLAR RENT-A-CAR"
                },
                {
                    "code": "3391",
                    "name": "EUROPE BY CAR"
                },
                {
                    "code": "3393",
                    "name": "NATIONAL CAR RENTAL"
                },
                {
                    "code": "3394",
                    "name": "KEMWELL GROUP RENT-A-CAR"
                },
                {
                    "code": "3395",
                    "name": "THRIFTY RENT-A-CAR"
                },
                {
                    "code": "3396",
                    "name": "TILDEN RENT-A-CAR"
                },
                {
                    "code": "3398",
                    "name": "ECONO-CAR RENT-A-CAR"
                },
                {
                    "code": "3399",
                    "name": "AMEREX RENT-A-CAR"
                },
                {
                    "code": "3400",
                    "name": "AUTO HOST CAR RENTALS"
                },
                {
                    "code": "3405",
                    "name": "ENTERPRISE RENT-A-CAR"
                },
                {
                    "code": "3409",
                    "name": "GENERAL RENT-A-CAR"
                },
                {
                    "code": "3411",
                    "name": "ATLANTA RENT-A-CAR"
                },
                {
                    "code": "3412",
                    "name": "A-1 RENT-A-CAR"
                },
                {
                    "code": "3414",
                    "name": "GODFREY NATL RENT-A-CAR"
                },
                {
                    "code": "3419",
                    "name": "APLHA RENT-A-CAR"
                },
                {
                    "code": "3420",
                    "name": "ANSA INTL RENT-A-CAR"
                },
                {
                    "code": "3421",
                    "name": "ALLSTATE RENT-A-CAR"
                },
                {
                    "code": "3423",
                    "name": "AVCAR RENT-A-CAR"
                },
                {
                    "code": "3425",
                    "name": "AUTOMATE RENT-A-CAR"
                },
                {
                    "code": "3427",
                    "name": "AVON RENT-A-CAR"
                },
                {
                    "code": "3428",
                    "name": "CAREY RENT-A-CAR"
                },
                {
                    "code": "3429",
                    "name": "INSURANCE RENT-A-CAR"
                },
                {
                    "code": "3430",
                    "name": "MAJOR RENT-A-CAR"
                },
                {
                    "code": "3431",
                    "name": "REPLACEMENT RENT-A-CAR"
                },
                {
                    "code": "3432",
                    "name": "RESERVE RENT-A-CAR"
                },
                {
                    "code": "3433",
                    "name": "UGLY DUCKLING RENT-A-CAR"
                },
                {
                    "code": "3434",
                    "name": "USA RENT-A-CAR"
                },
                {
                    "code": "3435",
                    "name": "VALUE RENT-A-CAR"
                },
                {
                    "code": "3436",
                    "name": "AUTOHANSA RENT-A-CAR"
                },
                {
                    "code": "3437",
                    "name": "CITE RENT-A-CAR"
                },
                {
                    "code": "3438",
                    "name": "INTERENT RENT-A-CAR"
                },
                {
                    "code": "3439",
                    "name": "MILLEVILLE RENT-A-CAR"
                },
                {
                    "code": "3440",
                    "name": "VIA ROUTE RENT-A-CAR"
                },
                {
                    "code": "3441",
                    "name": "ADVANTAGE RENT-A-CAR"
                },
                {
                    "code": "4011",
                    "name": "RAILROADS"
                },
                {
                    "code": "4111",
                    "name": "LOCAL/SUB COMMUTER PSGR TRNP, INCL FERRIES OR WATER TRNP"
                },
                {
                    "code": "4112",
                    "name": "PASSENGER RAILWAYS"
                },
                {
                    "code": "4119",
                    "name": "AMBULANCE SERVICES"
                },
                {
                    "code": "4121",
                    "name": "TAXICABS OR LIMOUSINES"
                },
                {
                    "code": "4131",
                    "name": "BUS LINES, INCLUDING CHARTERS, TOUR BUSES"
                },
                {
                    "code": "4214",
                    "name": "MOTOR FREIGHT CARRIERS, TRUCK-LOCAL/LONG"
                },
                {
                    "code": "4215",
                    "name": "COURIER SERVICES-AIR OR GROUND, FREIGHT"
                },
                {
                    "code": "4225",
                    "name": "PUBLIC WAREHOUSING-FARM PROD,REFRIDGERAT"
                },
                {
                    "code": "4457",
                    "name": "BOAT RENTALS AND LEASES"
                },
                {
                    "code": "4468",
                    "name": "MARINAS, MARINE SERVICE AND SUPPLIES"
                },
                {
                    "code": "4582",
                    "name": "AIRPORTS, AIRPORT TERMINALS OR FLYING FIELDS"
                },
                {
                    "code": "4761",
                    "name": "TRANSPORTATION/TRAVEL-RELATED ARRANGEMENT"
                },
                {
                    "code": "4784",
                    "name": "TOLLS, ROAD AND BRIDGE FEES"
                },
                {
                    "code": "4789",
                    "name": "TRANSPORTATION SERVICES (NEC)"
                },
                {
                    "code": "4812",
                    "name": "TELECOMMUNCATIONS EQUIPMENT INCLUDING TELEPHONE SALES"
                },
                {
                    "code": "4813",
                    "name": "KEY-ENTERED TELECOM MERCHANT"
                },
                {
                    "code": "4814",
                    "name": "TELECOMMUNCATIONS SERV INCL LOCA/LONG DIST CREDIT & FAX"
                },
                {
                    "code": "4815",
                    "name": "MONTHLY SUMMARY TELEPHONE CHARGES"
                },
                {
                    "code": "4816",
                    "name": "COMPUTER NETWORK/INFO SVCS"
                },
                {
                    "code": "4821",
                    "name": "TELEGRAPH SERVICES"
                },
                {
                    "code": "4829",
                    "name": "MONEY ORDERS -- WIRE TRANSFER"
                },
                {
                    "code": "4899",
                    "name": "CABLE AND OTHER PAY TELEVISION SERVICES"
                },
                {
                    "code": "4900",
                    "name": "ELECTRIC, GAS, SANITARY, TELEPHONE OR WATER UTILITIES"
                },
                {
                    "code": "5013",
                    "name": "MOTOR VEHICLE SUPPLIES AND NEW PARTS"
                },
                {
                    "code": "5021",
                    "name": "COMMERCIAL FURNITURE"
                },
                {
                    "code": "5039",
                    "name": "CONSTRUCTION MATERIALS (NEC)"
                },
                {
                    "code": "5044",
                    "name": "PHOTOGRAPHIC, PHOTOCOPY, MICROFILM EQUIPMENT AND SUPPLIES"
                },
                {
                    "code": "5045",
                    "name": "COMPUTERS AND COMPUTER PERIPHERAL EQUIPMENT AND SOFTWARE"
                },
                {
                    "code": "5046",
                    "name": "COMMERCIAL EQUIPMENT (NEC)"
                },
                {
                    "code": "5047",
                    "name": "MEDICAL, DENTAL, OPHTHALMIC AND HOSPITAL EQUIP"
                },
                {
                    "code": "5051",
                    "name": "METAL SERVICE CENTERS AND OFFICES"
                },
                {
                    "code": "5065",
                    "name": "ELECTRICAL PARTS AND EQUIPMENT"
                },
                {
                    "code": "5072",
                    "name": "HARDWARE, PLUMBING, HEATING EQUIPMENT AND SUPPLIES"
                },
                {
                    "code": "5074",
                    "name": "PLUMBING AND HEATING EQUIPMENT AND SUPPLIES"
                },
                {
                    "code": "5085",
                    "name": "INDUSTRIAL SUPPLIES (NEC)"
                },
                {
                    "code": "5094",
                    "name": "PRECIOUS STONES AND METALS, WATCHES AND JEWELRY"
                },
                {
                    "code": "5099",
                    "name": "DURABLE GOODS (NEC)"
                },
                {
                    "code": "5111",
                    "name": "STATIONERY, OFFICE SUPPLIES, PRINTING AND WRITING PAPER"
                },
                {
                    "code": "5122",
                    "name": "DRUGS, DRUG PROPRIETARIES AND DRUGGIST SUNDRIES"
                },
                {
                    "code": "5131",
                    "name": "PIECE GOODS, NOTIONS, AND OTHER DRY GOODS"
                },
                {
                    "code": "5137",
                    "name": "MEN'S, WOMEN'S AND CHILDREN'S UNIFORMS"
                },
                {
                    "code": "5139",
                    "name": "COMMERCIAL FOOTWEAR"
                },
                {
                    "code": "5169",
                    "name": "CHEMICALS AND ALLIED PRODUCTS (NEC)"
                },
                {
                    "code": "5172",
                    "name": "PETROLEUM AND PETROLEUM PRODUCTS"
                },
                {
                    "code": "5192",
                    "name": "BOOKS, PERIODICALS AND NEWSPAPERS"
                },
                {
                    "code": "5193",
                    "name": "FLORIST SUPPLIES, NURSERY STOCK AND FLOWERS"
                },
                {
                    "code": "5198",
                    "name": "PAINTS, VARNISHES AND SUPPLIES"
                },
                {
                    "code": "5199",
                    "name": "NON-DURABLE GOODS (NEC)"
                },
                {
                    "code": "5200",
                    "name": "HOME SUPPLY WAREHOUSE STORES"
                },
                {
                    "code": "5211",
                    "name": "LUMBER AND BUILDING MATERIALS STORES"
                },
                {
                    "code": "5231",
                    "name": "GLASS, PAINT OR WALLPAPER STORES"
                },
                {
                    "code": "5251",
                    "name": "HARDWARE STORES"
                },
                {
                    "code": "5261",
                    "name": "GARDEN AND LAWN SUPPLY STORES OR NURSERIES"
                },
                {
                    "code": "5271",
                    "name": "MOBILE HOME DEALERS"
                },
                {
                    "code": "5299",
                    "name": "WAREHOUSE CLUB GAS"
                },
                {
                    "code": "5300",
                    "name": "WHOLESALE CLUBS"
                },
                {
                    "code": "5309",
                    "name": "DUTY FREE STORES"
                },
                {
                    "code": "5310",
                    "name": "DISCOUNT STORES"
                },
                {
                    "code": "5311",
                    "name": "DEPARTMENT STORES"
                },
                {
                    "code": "5331",
                    "name": "VARIETY STORES"
                },
                {
                    "code": "5399",
                    "name": "GENERAL MERCHANDISE OR CONVENIENCE FOOD STORES"
                },
                {
                    "code": "5411",
                    "name": "GROCERY STORES OR SUPERMARKETS"
                },
                {
                    "code": "5422",
                    "name": "FREEZER AND LOCKER MEAT PROVISIONERS"
                },
                {
                    "code": "5441",
                    "name": "CANDY, CONFECTIONERY OR NUTS STORES"
                },
                {
                    "code": "5451",
                    "name": "DAIRY PRODUCTS STORES"
                },
                {
                    "code": "5462",
                    "name": "BAKERIES"
                },
                {
                    "code": "5499",
                    "name": "MISC FOOD STORES - SPECIALTY MARKETS & CONVENIENCE"
                },
                {
                    "code": "5511",
                    "name": "AUTO/TRUCK DEALERS NEW/USED SALE REPAIR PARTS & LEASE"
                },
                {
                    "code": "5521",
                    "name": "AUTOMOBILE AND TRUCK DEALERS (USED ONLY)"
                },
                {
                    "code": "5531",
                    "name": "AUTOMOBILE SUPPLY STORES OR HOME SUPPLY STORES"
                },
                {
                    "code": "5532",
                    "name": "AUTOMOTIVE TIRE STORES"
                },
                {
                    "code": "5533",
                    "name": "AUTOMOTIVE PARTS, ACCESSORIES STORES"
                },
                {
                    "code": "5541",
                    "name": "GAS/SERVICE STATIONS WITH/WITHOUT ANCILLARY SERVICES"
                },
                {
                    "code": "5542",
                    "name": "AUTOMATED FUEL DISPENSERS"
                },
                {
                    "code": "5551",
                    "name": "BOAT DEALERS"
                },
                {
                    "code": "5561",
                    "name": "RECREATIONAL & UTILITY TRAILERS, CAMPER DEALERS"
                },
                {
                    "code": "5571",
                    "name": "MOTORCYCLE DEALERS"
                },
                {
                    "code": "5592",
                    "name": "MOTOR HOME DEALERS"
                },
                {
                    "code": "5598",
                    "name": "SNOWMOBILE DEALERS"
                },
                {
                    "code": "5599",
                    "name": "AUTOMOTIVE DEALERS"
                },
                {
                    "code": "5611",
                    "name": "MEN'S AND/OR BOYS' CLOTHING AND ACCESSORIES STORES"
                },
                {
                    "code": "5621",
                    "name": "WOMEN'S READY-TO-WEAR STORES"
                },
                {
                    "code": "5631",
                    "name": "WOMEN'S ACCESSORY AND SPECIALTY SHOPS"
                },
                {
                    "code": "5641",
                    "name": "CHILDREN'S AND INFANTS' WEAR STORES"
                },
                {
                    "code": "5651",
                    "name": "FAMILY CLOTHING STORES"
                },
                {
                    "code": "5655",
                    "name": "RIDING OR SPORTS APPAREL STORES"
                },
                {
                    "code": "5661",
                    "name": "SHOE STORES"
                },
                {
                    "code": "5681",
                    "name": "FURRIERS AND FUR SHOPS"
                },
                {
                    "code": "5691",
                    "name": "MEN'S AND WOMEN'S CLOTHING STORES"
                },
                {
                    "code": "5697",
                    "name": "TAILORS, SEAMSTRESSES, MENDING & ALTERATIONS"
                },
                {
                    "code": "5698",
                    "name": "WIG AND TOUPEE STORES"
                },
                {
                    "code": "5699",
                    "name": "APPAREL AND ACCESSORY SHOPS -- MISCELLANEOUS"
                },
                {
                    "code": "5712",
                    "name": "FURNITURE, HOME FURNISHINGS & EQUIP STORES EXCL APPLIANCES"
                },
                {
                    "code": "5713",
                    "name": "FLOOR COVERING STORES"
                },
                {
                    "code": "5714",
                    "name": "DRAPERY, WINDOWCOVERING, AND UPHOLSTERY STORES"
                },
                {
                    "code": "5715",
                    "name": "ALCOHOLIC BEVERAGE WHOLESALERS"
                },
                {
                    "code": "5718",
                    "name": "FIREPLACES, FIREPLACE SCREENS AND ACCESSORIES STORES"
                },
                {
                    "code": "5719",
                    "name": "HOME FURNISHING SPECIALTY STORES -- MISCELLANEOUS"
                },
                {
                    "code": "5722",
                    "name": "APPLIANCE STORES (NEC) OR HOUSEHOLD APPLIANCE STORES"
                },
                {
                    "code": "5732",
                    "name": "ELECTRONIC SALES"
                },
                {
                    "code": "5733",
                    "name": "MUSIC STORES, MUSICAL INSTRUMENTS, PIANOS, SHEET MUSIC"
                },
                {
                    "code": "5734",
                    "name": "COMPUTER SOFTWARE STORES"
                },
                {
                    "code": "5735",
                    "name": "RECORD SHOPS"
                },
                {
                    "code": "5811",
                    "name": "CATERERS"
                },
                {
                    "code": "5812",
                    "name": "RESTAURANTS OR EATING PLACES"
                },
                {
                    "code": "5813",
                    "name": "ALCOHOLIC BEVERAGES DRINKING PLACES - BARS NIGHTCLUBS ETC"
                },
                {
                    "code": "5814",
                    "name": "FAST FOOD RESTAURANTS"
                },
                {
                    "code": "5815",
                    "name": "DIGITAL GOODS MEDIA: BOOKS, MOVIES, MUSIC"
                },
                {
                    "code": "5816",
                    "name": "DIGITAL GOODS: GAMES"
                },
                {
                    "code": "5817",
                    "name": "DIGITAL GOODS: APPLICATIONS (EXCLUDES GAMES)"
                },
                {
                    "code": "5818",
                    "name": "LARGE DIGITAL GOODS MERCHANT"
                },
                {
                    "code": "5912",
                    "name": "PHARMCIES OR DRUG STORES"
                },
                {
                    "code": "5921",
                    "name": "LIQUOR, WINE, PACKAGE OR BEER STORES"
                },
                {
                    "code": "5931",
                    "name": "SECONDHAND OR USED MERCHANDISE STORES"
                },
                {
                    "code": "5932",
                    "name": "ANTIQUE SHOPS"
                },
                {
                    "code": "5933",
                    "name": "PAWN SHOPS"
                },
                {
                    "code": "5935",
                    "name": "WRECKING & SALVAGE YARDS"
                },
                {
                    "code": "5937",
                    "name": "ANTIQUE REPRODUCTIONS"
                },
                {
                    "code": "5940",
                    "name": "BICYCLE SHOPS -- SALES AND SERVICE"
                },
                {
                    "code": "5941",
                    "name": "SPORTING GOODS STORES"
                },
                {
                    "code": "5942",
                    "name": "BOOK STORES"
                },
                {
                    "code": "5943",
                    "name": "STATIONERY STORES, OFFICE & SCHOOL SUPPLY STORES"
                },
                {
                    "code": "5944",
                    "name": "CLOCK, JEWELRY, SILVERWARE OR WATCH STORES"
                },
                {
                    "code": "5945",
                    "name": "HOBBY, TOY OR GAMES STORES"
                },
                {
                    "code": "5946",
                    "name": "CAMERA AND/OR PHOTOGRAPHIC SUPPLY STORES"
                },
                {
                    "code": "5947",
                    "name": "CARD, GIFT, NOVELTY OR SOUVENIR SHOPS"
                },
                {
                    "code": "5948",
                    "name": "LUGGAGE OR LEATHER GOODS STORES"
                },
                {
                    "code": "5949",
                    "name": "NEEDLEWORK, SEWING OR FABRIC AND PIECE GOODS STORES"
                },
                {
                    "code": "5950",
                    "name": "GLASSWARE/CRYSTAL STORES"
                },
                {
                    "code": "5960",
                    "name": "DIRECT MARKETING INSURANCE SERVICES"
                },
                {
                    "code": "5961",
                    "name": "MAIL ORDER HOUSES INCL CATALOG ORDER STORES BOOK/RECORD CLUB"
                },
                {
                    "code": "5963",
                    "name": "DOOR-TO-DOOR SALES OR DIRECT SELLING ESTABLISHMENTS"
                },
                {
                    "code": "5964",
                    "name": "CATALOG MERCHANT"
                },
                {
                    "code": "5965",
                    "name": "COMBINATION CATALOG AND RETAIL MERCHANT"
                },
                {
                    "code": "5966",
                    "name": "OUTBOUND TELEMARKETING MERCHANT"
                },
                {
                    "code": "5967",
                    "name": "INBOUND TELESERVICES MERCHANT"
                },
                {
                    "code": "5969",
                    "name": "DIRECT MARKETERS (NEC)"
                },
                {
                    "code": "5970",
                    "name": "CRAFT OR ARTIST'S SUPPLY SHOPS"
                },
                {
                    "code": "5971",
                    "name": "ART DEALERS OR GALLERIES"
                },
                {
                    "code": "5972",
                    "name": "STAMP AND COIN STORES"
                },
                {
                    "code": "5973",
                    "name": "RELIGIOUS GOODS STORES"
                },
                {
                    "code": "5974",
                    "name": "RUBBER STAMP STORES/RESERVED FOR NATIONAL USE"
                },
                {
                    "code": "5975",
                    "name": "HEARING AIDS -- SALES, SERVICE AND SUPPLY STORES"
                },
                {
                    "code": "5976",
                    "name": "ORTHOPEDIC GOODS, PROSTHETIC DEVICES"
                },
                {
                    "code": "5977",
                    "name": "COSMETIC STORES"
                },
                {
                    "code": "5978",
                    "name": "TYPEWRITER STORES -- SALES, RENTALS, SERVICE"
                },
                {
                    "code": "5983",
                    "name": "FUEL DEALERS-FUEL,OIL,WOOD,COAL,LIQUE"
                },
                {
                    "code": "5992",
                    "name": "FLORISTS"
                },
                {
                    "code": "5993",
                    "name": "CIGAR STORES AND STANDS"
                },
                {
                    "code": "5994",
                    "name": "NEWS DEALERS AND NEWSSTANDS"
                },
                {
                    "code": "5995",
                    "name": "PET SHOPS, PET FOODS AND SUPPLIES STORES"
                },
                {
                    "code": "5996",
                    "name": "SWIMMING POOLS -- SALES, SERVICE AND SUPPLIES"
                },
                {
                    "code": "5997",
                    "name": "ELECTRIC RAZOR STORES -- SALES AND SERVICE"
                },
                {
                    "code": "5998",
                    "name": "AWNING AND TENT SHOPS"
                },
                {
                    "code": "5999",
                    "name": "MISCELLANEOUS & SPECIALTY STORES"
                },
                {
                    "code": "6010",
                    "name": "FINANCIAL INSTITUTIONS - MANUAL CASH DISBURSEMENTS"
                },
                {
                    "code": "6011",
                    "name": "FINANCIAL INSTITUTIONS - AUTOMATED CASH DISBURSEMENTS"
                },
                {
                    "code": "6012",
                    "name": "FINANCIAL INSTITUTIONS - MERCHANDISE & SERVICES"
                },
                {
                    "code": "6050",
                    "name": "QUASI CASH-MEMBER FINANCIAL INSTITUTION"
                },
                {
                    "code": "6051",
                    "name": "QUASI CASH"
                },
                {
                    "code": "6211",
                    "name": "SECURITY BROKERS/DEALERS"
                },
                {
                    "code": "6300",
                    "name": "INSURANCE SALES AND UNDERWRITING"
                },
                {
                    "code": "6381",
                    "name": "INSURANCE PREMIUMS"
                },
                {
                    "code": "6399",
                    "name": "INSURANCE (NEC)"
                },
                {
                    "code": "6513",
                    "name": "REAL ESTATE AGENTS AND MANAGERS-RENTALS"
                },
                {
                    "code": "6529",
                    "name": "REMOTE STORED VALUE LOAD-MEMBER FINANCIAL INSTITUTION"
                },
                {
                    "code": "6530",
                    "name": "REMOTE STORED VALUE LOAD"
                },
                {
                    "code": "6531",
                    "name": "PAYMENT SERVICE PROVIDER-MONEY TRANSFER"
                },
                {
                    "code": "6532",
                    "name": "PAYMENT TRANSACTION - MEMBER FINANCIAL I"
                },
                {
                    "code": "6533",
                    "name": "PAYMENT TRANSACTION - MERCHANT"
                },
                {
                    "code": "6534",
                    "name": "MONEY TRANSFER-MEMBER FINANCIAL INSTITUT"
                },
                {
                    "code": "6535",
                    "name": "VALUE PURCHASE-MEMBER FINANCIAL INSTITUT"
                },
                {
                    "code": "6536",
                    "name": "MONEYSEND INTRACOUNTRY"
                },
                {
                    "code": "6537",
                    "name": "MONEYSEND INTERCOUNTRY"
                },
                {
                    "code": "6538",
                    "name": "MASTERCARD MONEYSEND FUNDING TRANSACTION"
                },
                {
                    "code": "6540",
                    "name": "POI FUNDING TRANSACTIONS"
                },
                {
                    "code": "6555",
                    "name": "MASTERCARD INITIATED REBATE/REWARDS"
                },
                {
                    "code": "6611",
                    "name": "OVERPAYMENTS"
                },
                {
                    "code": "6760",
                    "name": "SAVINGS BONDS"
                },
                {
                    "code": "7012",
                    "name": "TIMESHARES"
                },
                {
                    "code": "7032",
                    "name": "SPORT/RECREATIONAL CAMPS"
                },
                {
                    "code": "7033",
                    "name": "CAMPGROUNDS OR TRAILER PARKS"
                },
                {
                    "code": "7210",
                    "name": "CLEANING, LAUNDRY AND GARMENT SERVICES"
                },
                {
                    "code": "7211",
                    "name": "DIAPER SERVICES OR LAUNDROMATS"
                },
                {
                    "code": "7216",
                    "name": "DRY CLEANERS"
                },
                {
                    "code": "7217",
                    "name": "UPHOLSTERY CLEANING OR CARPET CLEANING"
                },
                {
                    "code": "7221",
                    "name": "PHOTOGRAPHIC STUDIOS"
                },
                {
                    "code": "7230",
                    "name": "BARBER OR BEAUTY SHOPS"
                },
                {
                    "code": "7251",
                    "name": "SHOE REPAIR SHOPS, SHOE SHINE PARLORS"
                },
                {
                    "code": "7261",
                    "name": "CREMATORIES OR FUNERAL SERVICES"
                },
                {
                    "code": "7272",
                    "name": "ESCORT SERVICES"
                },
                {
                    "code": "7273",
                    "name": "DATING OR ESCORT SERVICES"
                },
                {
                    "code": "7276",
                    "name": "TAX PREPARATION SERVICE"
                },
                {
                    "code": "7277",
                    "name": "COUNSELING SERVICE -- DEBT, MARRIAGE, PERSONAL"
                },
                {
                    "code": "7278",
                    "name": "BUYING OR SHOPPING SERVICES CLUBS"
                },
                {
                    "code": "7280",
                    "name": "HOSPITAL PATIENT PERSONAL FUNDS WITHDRAW"
                },
                {
                    "code": "7295",
                    "name": "BABYSITTING SERVICES"
                },
                {
                    "code": "7296",
                    "name": "CLOTHING RENTAL -- COSTUMES, FORMAL WEAR, UNIFORMS"
                },
                {
                    "code": "7297",
                    "name": "MASSAGE PARLORS"
                },
                {
                    "code": "7298",
                    "name": "BEAUTY OR HEALTH SPAS"
                },
                {
                    "code": "7299",
                    "name": "MISC PERSONAL SERVICES NOT ELSEWHERE CLASSIFIED"
                },
                {
                    "code": "7311",
                    "name": "ADVERTISING SERVICES"
                },
                {
                    "code": "7321",
                    "name": "CONSUMER CREDIT REPORTING AGENCIES"
                },
                {
                    "code": "7322",
                    "name": "DEBT COLLECTION AGENCIES"
                },
                {
                    "code": "7332",
                    "name": "PHOTOCOPYING & BLUEPRINTING SERVICES"
                },
                {
                    "code": "7333",
                    "name": "PHOTOGRAPHY, ART AND GRAPHIC -- COMMERCIAL"
                },
                {
                    "code": "7338",
                    "name": "PRINT SHOPS, QUICK COPY SERVICES OR REPRODUCTION SERVICES"
                },
                {
                    "code": "7339",
                    "name": "STENOGRAPHIC SERVICES"
                },
                {
                    "code": "7341",
                    "name": "WINDOW CLEANING SERVICES"
                },
                {
                    "code": "7342",
                    "name": "DISINFECTING OR EXTERMINATING SERVICES"
                },
                {
                    "code": "7349",
                    "name": "CLEANING AND MAINTENANCE, JANITORIAL SERVICES"
                },
                {
                    "code": "7361",
                    "name": "EMPLOYMENT AGENCIES OR TEMPORARY HELP SERVICES"
                },
                {
                    "code": "7372",
                    "name": "COMPUTER PROGRAMMING, SYSTEMS DESIGN OR DATA PROCESSING SERV"
                },
                {
                    "code": "7375",
                    "name": "INFORMATION RETRIEVAL SERVICES"
                },
                {
                    "code": "7379",
                    "name": "COMPUTER MAINTENANCE, REPAIR AND SERVICES"
                },
                {
                    "code": "7392",
                    "name": "MANAGEMENT, PUBLIC RELATIONS OR CONSULTING SERVICES"
                },
                {
                    "code": "7393",
                    "name": "DETECTIVE AGENCY, PROTECTIVE SERV, GUARD DOG, ARMORED CAR"
                },
                {
                    "code": "7394",
                    "name": "EQUIP, TOOL, FURNITURE, APPLIANCE LEASE/RENTAL"
                },
                {
                    "code": "7395",
                    "name": "PHOTOFINISHING LABORATORIES, PHOTO DEVELOPING"
                },
                {
                    "code": "7399",
                    "name": "BUSINESS SERVICES (NEC)"
                },
                {
                    "code": "7511",
                    "name": "TRUCK STOP TRANSACTIONS"
                },
                {
                    "code": "7512",
                    "name": "CAR RENTAL AGENCIES -- NOT LISTED BELOW"
                },
                {
                    "code": "7513",
                    "name": "RENTALS -- TRUCKS, TRAILERS OR UTILITY TRAILERS"
                },
                {
                    "code": "7519",
                    "name": "RECREATIONAL VEHICLE RENTALS OR MOTOR HOME RENTALS"
                },
                {
                    "code": "7523",
                    "name": "AUTOMOBILE PARKING OR PARKING LOTS"
                },
                {
                    "code": "7524",
                    "name": "EXPRESS PAYMENT SERVICES - PARKING/GARAGE"
                },
                {
                    "code": "7531",
                    "name": "AUTOMOTIVE BODY REPAIR SHOPS"
                },
                {
                    "code": "7534",
                    "name": "TIRE RETREADING AND REPAIR SHOPS"
                },
                {
                    "code": "7535",
                    "name": "AUTOMOTIVE PAINT SHOPS"
                },
                {
                    "code": "7538",
                    "name": "AUTOMOTIVE SERVICE SHOPS (NON-DEALER)"
                },
                {
                    "code": "7542",
                    "name": "CAR WASHES"
                },
                {
                    "code": "7549",
                    "name": "TOWING SERVICES"
                },
                {
                    "code": "7622",
                    "name": "RADIO, STEREO OR TELEVISION REPAIR SHOPS"
                },
                {
                    "code": "7623",
                    "name": "AIR CONDITIONING  OR REFRIGERATION REPAIR SHOPS"
                },
                {
                    "code": "7629",
                    "name": "APPLIANCE OR ELECTRICAL REPAIR SHOPS"
                },
                {
                    "code": "7631",
                    "name": "CLOCK, JEWELRY OR WATCH  REPAIR"
                },
                {
                    "code": "7641",
                    "name": "REUPHOLSTERY AND FURNITURE REPAIR"
                },
                {
                    "code": "7692",
                    "name": "WELDING"
                },
                {
                    "code": "7699",
                    "name": "REPAIR SHOPS AND RELATED SERVICES -- MISCELLANEOUS"
                },
                {
                    "code": "7800",
                    "name": "GOVERNMENT-OWNED LOTTERIES"
                },
                {
                    "code": "7801",
                    "name": "GOVERNMENT LICENSED CASINOS (ONLINE GAMBLING)"
                },
                {
                    "code": "7802",
                    "name": "GOVERNMENT LICENSED HORSE/DOG RACING"
                },
                {
                    "code": "7829",
                    "name": "MOTION PICTURE AND VIDEO TAPE PRODUCTION AND DISTRIBUTION"
                },
                {
                    "code": "7833",
                    "name": "EXPRESS PAYMENT SERVICES - MOTION PICTURE"
                },
                {
                    "code": "7841",
                    "name": "VIDEO TAPE RENTAL STORES"
                },
                {
                    "code": "7911",
                    "name": "DANCE HALLS, STUDIOS AND SCHOOLS"
                },
                {
                    "code": "7929",
                    "name": "BANDS, ORCHESTRAS OR ENTERTAINERS"
                },
                {
                    "code": "7932",
                    "name": "BILLIARD AND POOL ESTABLISHMENTS"
                },
                {
                    "code": "7933",
                    "name": "BOWLING ALLEYS"
                },
                {
                    "code": "7941",
                    "name": "COMMERCIAL/PROFESSIONAL SPORTS, PROMOTERS, ATHLETIC FIELDS"
                },
                {
                    "code": "7991",
                    "name": "TOURIST ATTRACTIONS AND EXHIBITS"
                },
                {
                    "code": "7992",
                    "name": "GOLF COURSES -- PUBLIC"
                },
                {
                    "code": "7993",
                    "name": "VIDEO AMUSEMENT GAME SUPPLIES"
                },
                {
                    "code": "7994",
                    "name": "VIDEO GAME ARCADES/ESTABLISHMENTS"
                },
                {
                    "code": "7995",
                    "name": "BETTING, WAGERING, LOTTERY, GAMBLING TICKETS OR CHIPS"
                },
                {
                    "code": "7996",
                    "name": "AMUSEMENT PARKS, CARNIVALS, CIRCUSES OR FORTUNE TELLERS"
                },
                {
                    "code": "7998",
                    "name": "AQUARIUMS, SEAQUARIUMS, DOLPHINARIUMS"
                },
                {
                    "code": "7999",
                    "name": "AMUSEMENT/RECREATIONAL SERVICES NOT ELSEWHERE CLASSIFIED"
                },
                {
                    "code": "8011",
                    "name": "DOCTORS OR PHYSICIANS"
                },
                {
                    "code": "8021",
                    "name": "DENTISTS OR ORTHODONTISTS"
                },
                {
                    "code": "8031",
                    "name": "OSTEOPATHS"
                },
                {
                    "code": "8041",
                    "name": "CHIROPRACTORS"
                },
                {
                    "code": "8042",
                    "name": "OPHTHALMOLOGISTS OR OPTOMETRISTS"
                },
                {
                    "code": "8043",
                    "name": "OPTICIANS"
                },
                {
                    "code": "8044",
                    "name": "EYEGLASSES STORES OR OPTICAL GOODS"
                },
                {
                    "code": "8049",
                    "name": "CHIROPODISTS OR PODIATRISTS"
                },
                {
                    "code": "8050",
                    "name": "CONVALESCENT HOMES OR NURSING AND PERSONAL CARE FACILITIES"
                },
                {
                    "code": "8062",
                    "name": "HOSPITALS"
                },
                {
                    "code": "8071",
                    "name": "DENTAL LABORATORIES OR MEDICAL LABORATORIES"
                },
                {
                    "code": "8099",
                    "name": "MEDICAL SERVICES AND HEALTH PRACTITIONERS (NEC)"
                },
                {
                    "code": "8111",
                    "name": "ATTORNEYS OR LEGAL SERVICES"
                },
                {
                    "code": "8211",
                    "name": "ELEMENTARY OR SECONDARY SCHOOLS"
                },
                {
                    "code": "8220",
                    "name": "UNIVERSITIES, COLLEGES, SR COLLEGES OR PROFESSIONAL SCHOOLS"
                },
                {
                    "code": "8241",
                    "name": "CORRESPONDENCE SCHOOLS"
                },
                {
                    "code": "8244",
                    "name": "BUSINESS SCHOOLS OR SECRETARIAL SCHOOLS"
                },
                {
                    "code": "8249",
                    "name": "VOCATIONAL OR TRADE SCHOOLS"
                },
                {
                    "code": "8299",
                    "name": "SCHOOLS AND EDUCATIONAL SERVICES (NEC)"
                },
                {
                    "code": "8351",
                    "name": "DAY OR CHILD CARE SERVICES"
                },
                {
                    "code": "8398",
                    "name": "CHARITABLE  OR SOCIAL SERVICES ORGANIZATIONS"
                },
                {
                    "code": "8641",
                    "name": "SOCIAL, FRATERNAL OR CIVIC ASSOCIATIONS"
                },
                {
                    "code": "8651",
                    "name": "POLITICAL ORGANIZATIONS"
                },
                {
                    "code": "8661",
                    "name": "RELIGIOUS ORGANIZATIONS"
                },
                {
                    "code": "8675",
                    "name": "AUTOMOBILE ASSOCIATIONS"
                },
                {
                    "code": "8699",
                    "name": "MEMBERSHIP ORGANIZATIONS NOT ELSEWHERE CLASSIFIED"
                },
                {
                    "code": "8734",
                    "name": "TESTING LABORATORIES (NON-MEDICAL TESTING)"
                },
                {
                    "code": "8911",
                    "name": "ARCHITECTURAL, ENGINEERING AND SURVEYING SERVICES"
                },
                {
                    "code": "8931",
                    "name": "ACCOUNTING, BOOKKEEPING OR AUDITING SERVICES"
                },
                {
                    "code": "8999",
                    "name": "PROFESSIONAL SERVICES (NEC)"
                },
                {
                    "code": "9211",
                    "name": "ALIMONY, CHILD SUPPORT OR COURT COSTS"
                },
                {
                    "code": "9222",
                    "name": "FINES"
                },
                {
                    "code": "9223",
                    "name": "BAIL AND BOND PAYMENTS"
                },
                {
                    "code": "9311",
                    "name": "TAX PAYMENTS"
                },
                {
                    "code": "9399",
                    "name": "GOVERNMENT SERVICES (NEC) OR FIRE DEPARTMENTS"
                },
                {
                    "code": "9401",
                    "name": "I-PURCHASING PILOT"
                },
                {
                    "code": "9402",
                    "name": "POSTAGE STAMPS"
                },
                {
                    "code": "9405",
                    "name": "INTERGOVERMENT TRANSACTIONS"
                },
                {
                    "code": "9411",
                    "name": "GOVERNMENT LOAN PAYMENTS"
                },
                {
                    "code": "9700",
                    "name": "AUTOMATED REFERRAL SERVICE"
                },
                {
                    "code": "9701",
                    "name": "VISA CREDENTIAL SERVER"
                },
                {
                    "code": "9702",
                    "name": "GCAS EMERGENCY SERVICES (VISA USE ONLY)"
                },
                {
                    "code": "9751",
                    "name": "U.K. SUPERMARKETS, ELECTRONIC HOT FILE"
                },
                {
                    "code": "9752",
                    "name": "U.K. PETROL STATIONS, ELECTRONIC HOT FILE"
                },
                {
                    "code": "9754",
                    "name": "GAMBLING-HORSE, DOG RACING-ST LOTTERY"
                },
                {
                    "code": "9950",
                    "name": "INTRA-COMPANY PURCHASES"
                },
                {
                    "code": "9999",
                    "name": "CLIENT DEFINED MCC"
                }
            ],
        }
    }
}
